<template>
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2222 1.77778H10.5067C10.1333 0.746667 9.15556 0 8 0C6.84444 0 5.86667 0.746667 5.49333 1.77778H1.77778C1.65333 1.77778 1.53778 1.78667 1.42222 1.81333C1.13912 1.87273 0.874703 2.00004 0.651725 2.18431C0.428748 2.36858 0.253895 2.60427 0.142222 2.87111C0.0533334 3.07556 0 3.30667 0 3.55556V16C0 16.24 0.0533334 16.48 0.142222 16.6933C0.231111 16.9067 0.364444 17.0933 0.524444 17.2622C0.764444 17.5022 1.07556 17.68 1.42222 17.7511C1.53778 17.7689 1.65333 17.7778 1.77778 17.7778H14.2222C15.2 17.7778 16 16.9778 16 16V3.55556C16 2.57778 15.2 1.77778 14.2222 1.77778ZM7.11111 11.7067L5.85778 12.9689L2.66667 9.77778L5.85778 6.58667L7.11111 7.84889L5.18222 9.77778L7.11111 11.7067ZM8 2.88889C7.63556 2.88889 7.33333 2.58667 7.33333 2.22222C7.33333 1.85778 7.63556 1.55556 8 1.55556C8.36444 1.55556 8.66667 1.85778 8.66667 2.22222C8.66667 2.58667 8.36444 2.88889 8 2.88889ZM10.1422 12.9689L8.88889 11.7067L10.8178 9.77778L8.88889 7.84889L10.1422 6.58667L13.3333 9.77778L10.1422 12.9689Z"
      fill="currentcolor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IntegrationIcon',
}
</script>

<style scoped>

</style>
